(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    

if (!customElements.get('hd-infinite-scroll')) {
  customElements.define('hd-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-section-type="collection-template"]');
      this.grid = this.root?.querySelector('.filters-adjacent .product-list');
      this.next = this.dataset.next;
      if (!this.grid || !this.next || !('IntersectionObserver' in window)) return;
      this.link = this.querySelector('[data-hd-next]');
      this.fallback = this.querySelector('[data-hd-pagination]');
      this.fallback.hidden = true;
      this.classList.add('hd-scroll-ready');
      this.onClick = (event) => {
        if (!event.target.closest('[data-hd-next]')) return;
        event.preventDefault();
        this.failed = false;
        this.loadNext(true);
      };
      this.addEventListener('click', this.onClick);
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting) && !this.failed) this.loadNext(false);
      }, { rootMargin: '0px 0px 400px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.removeEventListener('click', this.onClick);
    }
    async loadNext(keyboard) {
      if (this.loading || !this.next || !this.isConnected || this.root.querySelector('.ajax-loading')) return;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.grid.setAttribute('aria-busy', 'true');
      const currentUrl = location.href;
      const grid = this.grid;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 20000);
      try {
        const url = new URL(this.next, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid pagination origin');
        const preview = new URL(currentUrl).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.searchParams.set('section_id', this.root.dataset.sectionId);
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Pagination request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || !grid.isConnected || location.href !== currentUrl || this.root.querySelector('.ajax-loading')) return;
        const incomingGrid = doc.querySelector('.filters-adjacent .product-list');
        const incomingPager = doc.querySelector('hd-infinite-scroll');
        if (!incomingGrid || !incomingPager) throw new Error('Missing collection markup');
        const existing = new Set(Array.from(grid.querySelectorAll('[data-product-id]'), card => card.dataset.productId));
        const cards = Array.from(incomingGrid.children).filter(card => {
          const id = card.dataset.productId;
          if (!id || existing.has(id)) return false;
          existing.add(id);
          return true;
        });
        if (!cards.length && incomingPager.dataset.next) throw new Error('No new products');
        grid.append(...cards);
        this.next = incomingPager.dataset.next || '';
        this.dataset.next = this.next;
        const fallback = incomingPager.querySelector('[data-hd-pagination]');
        if (fallback) this.fallback.innerHTML = fallback.innerHTML;
        if (this.next) this.link.href = this.next;
        else {
          this.observer.disconnect();
          this.link.hidden = true;
          this.classList.add('hd-scroll-complete');
        }
        if (window.theme?.ProductBlockManager && window.jQuery) {
          window.theme.ProductBlockManager.loadImages(window.jQuery(grid));
        }
        window.theme?.initAnimateOnScroll?.();
        if (keyboard && cards[0]) {
          const focusTarget = cards[0].querySelector('.product-info .product-link');
          focusTarget?.focus({ preventScroll: true });
        }
        this.classList.remove('hd-scroll-error');
        this.observer.unobserve(this);
        if (this.next) this.observer.observe(this);
      } catch (error) {
        if (this.isConnected && location.href === currentUrl) {
          this.failed = true;
          this.classList.add('hd-scroll-error');
          this.fallback.hidden = false;
        }
      } finally {
        clearTimeout(timeout);
        this.loading = false;
        this.setAttribute('aria-busy', 'false');
        grid.removeAttribute('aria-busy');
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
